import { Injectable } from '@angular/core';
import { RequestMethodsService } from '../commons/request_methods';
import { Constants } from '../commons/constants';

@Injectable()
export class ManualPointService {

    constructor(
        private requestMethodService: RequestMethodsService,
        private constants: Constants){}

        getManualPoints(token, assetId,lan) {
            let API_URL = window.sessionStorage.getItem('isNetCoreUser') === "true" ? this.constants.NETCORE_BASE_URL : this.constants.LEGACY_BASE_URL;
            return this.requestMethodService.get(
                token,
                API_URL,
                this.constants.GET_MANUAL_POINTS,
                {
                    assetId: assetId,
                    lang:lan
                }
            );
        }

    postManualPoints(token, body) {
        let API_URL = window.sessionStorage.getItem('isNetCoreUser') === "true" ? this.constants.NETCORE_BASE_URL : this.constants.LEGACY_BASE_URL;
        return this.requestMethodService.post(
            token,
            API_URL + this.constants.POST_MANUAL_POINT_READINGS,
            body
        );
    }

        createPdf(token, body){
            return this.requestMethodService.post(
                token,
                this.constants.POST_BLOB,
                body
            );
        }

        sendEmail(token, body) {
            return this.requestMethodService.post(
                token,
                this.constants.SEND_EMAIL,
                body
            )
        }

        getLogReports(token, assetId) {
            let API_URL = window.sessionStorage.getItem('isNetCoreUser') === "true" ? this.constants.NETCORE_BASE_URL : this.constants.LEGACY_BASE_URL;
            return this.requestMethodService.get(
                token,
                API_URL,
                this.constants.GET_LOG_REPORTS,
                {
                    assetId: assetId
                }
            );
        }
        
        saveLogReportsToDB(token, body){
            let API_URL = window.sessionStorage.getItem('isNetCoreUser') === "true" ? this.constants.NETCORE_BASE_URL : this.constants.LEGACY_BASE_URL;
            return this.requestMethodService.post(
                token,
                API_URL + this.constants.SAVE_LOG_REPORTS_TO_DB,
                body
            );
        }

        sendEmailNew(token, body) {
            return this.requestMethodService.post(
                token,
                this.constants.SendMail,
                body
            )
        }
}


// WEBPACK FOOTER //
// ./src/services/manual-point.service.ts